// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Component, Fragment } from 'react';
import '../styles/containers/Event.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment-timezone';
import { AxiosError } from 'axios';

import * as OrdersService from '../services/OrdersService';
import TableSortingElem from '../infrastructure/TableSorting';
import * as Service from '../services/PartiesService';
import { EventForm } from '../components/forms/events/EventForm';
import Error from '../components/stateMessage/Error';
import Spinner from '../components/utils/Spinner';
import TopPanel from '../components/utils/TopPanel';
import Modal from '../components/utils/ModalComponet';
import {
  getMatchByPath,
  getAllDatesFromInterval,
  getCurrentDate,
} from '../infrastructure/utils/common';
import EventView from '../components/events/EventView';
import {
  FLIGHT_TRAVEL,
  GROUND_TRAVEL,
} from '../components/forms/events/EventCategory';
import FlightEventView from '../components/events/FlightEventView';
import Succsess from '../components/stateMessage/Succsess';
import EventOrderList from '../components/orders/EventOrdersList';
import GroundTransportEventView from '../components/events/GroundTransportEventView';
import * as ActivityService from '../services/ActivitiesService';

const initialState = {
  deactive: false,
  event: null,
  party: null,
  backpage: false,
  openModal: false,
  modalContent: () => [],
  modalAction: undefined,
  actionButtonText: 'Delete',
  eventUpdated: false,
  serverError: false,
};

export class Event extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  async componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;
    try {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      if (history.length > 2) {
        this.setState({ backpage: true });
      }
      const match = getMatchByPath(
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        history.location.pathname,
        '/party/:id/event/:eventid'
      );
      const { id, eventid } = match.params;
      const [event, party, images, orders] = await Promise.all([
        Service.getEventById(eventid),
        Service.getParty(id),
        Service.getDefaultImagesForEvent(),
        OrdersService.getOrdersByParty(
          id,
          new TableSortingElem({ name: 'totalPrice', isString: true })
        ),
      ]);
      let activity;
      if (event[0].activityId) {
        activity = await ActivityService.getById(event[0].activityId);
      }
      const dates = getAllDatesFromInterval(
        party.startDate,
        party.endDate,
        party.tz
      );
      const eventOrders = this.getOrders({ event: event[0], orders });
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      const { deactive } = this.state;
      if (!deactive) {
        this.setState({
          event: event[0],
          party,
          images,
          dates,
          eventOrders,
          activity,
        });
      }
    } catch (e) {
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
      console.log(error.message);
    }
  }

  componentWillUnmount() {
    this.setState({ deactive: true });
  }

  toOrderInfo = order => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    history.push(order);
  };

  getOrders = ({ event, orders }) =>
    event.orders
      ? event.orders.map(order =>
          orders.find(elem => elem.id === order.orderId)
        )
      : [];

  back = () => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    history.goBack();
  };

  closeModal = () => {
    this.setState({ openModal: false });
  };

  deleteEvent = () => {
    this.setState({
      openModal: true,
      modalContent: this.renderDeleteMessage,
      modalAction: this.toDelete,
      actionButtonText: 'Delete',
    });
  };

  handleSubmit = event => {
    this.setState({ event, openModal: false, eventUpdated: true });
    Service.updateEvent(event);
    setTimeout(this.hideMessage, 5 * 1000);
  };

  hideMessage = () => {
    this.setState({ serverError: false, eventUpdated: false });
  };

  toDelete = async () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { event } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;
    try {
      await Service.deleteEvent(event.partyId, event.eventId);
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      history.push(`/party/${event.partyId}`);
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        serverError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  getTravelType = type => {
    if (type === undefined || type === 'Flight') {
      return 'Flight';
    }
    if (type === 'Train') {
      return 'Train';
    }
    if (type === 'Drive') {
      return 'Drive';
    }
    return 'Other Travel';
  };

  toEdit = () => {
    this.setState({
      openModal: true,
      modalContent: this.renderEventForm,
      modalAction: undefined,
    });
  };

  renderEventForm = () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { dates, party, event, images } = this.state;
    const start = dates[0]
      ? dates[0]
      : getCurrentDate(new Date().toISOString(), party.tz);
    const end = party.endDate ? party.endDate : '';
    const partyLocation = party.partyLocation
      ? party.partyLocation.address
      : '';
    return (
      <EventForm
        event={event}
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        handleEventSubmit={this.handleSubmit}
        back={this.back}
        partyMembers={party.members.filter(member => !member.joinedAs)}
        partyLocation={partyLocation}
        images={images}
        startDate={start}
        endDate={end}
        offset={party.timeOffset}
        tz={party.tz}
      />
    );
  };

  renderDeleteMessage = () => (
    <div style={{ marginBottom: '40px' }}>
      Are you sure you want to delete this event?
    </div>
  );

  render() {
    const {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      event,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      backpage,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      serverError,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      eventUpdated,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      openModal,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      modalContent,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      modalAction,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      actionButtonText,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      party,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      eventOrders,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      activity,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      images,
    } = this.state;

    const loaded = event != null;
    if (!loaded) {
      return <Spinner />;
    }
    let name = event.eventTitle === null ? '' : event.eventTitle;
    const title = event.eventTitle || '';
    let startTime = `${
      !event.dateTBD
        ? moment(event.startTime).tz(party.tz).format('MMM DD')
        : 'Date TBD'
    } ${
      !event.timeTBD
        ? moment(event.startTime).tz(party.tz).format('hh:mm A z')
        : 'Time TBD'
    }`;
    let endTime = ` - ${
      !event.timeTBD
        ? moment(event.endTime).tz(party.tz).format('hh:mm A z')
        : 'Time TBD'
    }`;
    if (event.eventCategory === 'Lodging') {
      startTime = `${
        !event.dateTBD
          ? moment(event.startTime).tz(party.tz).format('MMM DD')
          : 'Date TBD'
      } Check In ${
        !event.timeTBD
          ? moment(event.startTime).tz(party.tz).format('hh:mm A z')
          : 'Time TBD'
      }`;
      endTime = ` - ${
        !event.dateTBD
          ? moment(event.endTime).tz(party.tz).format('MMM DD')
          : 'Date TBD'
      } Check Out ${
        !event.timeTBD
          ? moment(event.endTime).tz(party.tz).format('hh:mm A')
          : 'Time TBD'
      }`;
      name = `Accommodation in ${event.eventName}`;
    }
    if (event.eventCategory === 'Flight') {
      startTime = `${
        !event.dateTBD
          ? moment(event.startTime).tz(event.startTz).format('MMM DD')
          : 'Date TBD'
      }  ${
        !event.timeTBD
          ? moment(event.startTime).tz(event.startTz).format('hh:mm A z')
          : 'Time TBD'
      } `;
      endTime = ` - ${
        !event.dateTBD
          ? moment(event.endTime).tz(event.endTz).format('MMM DD')
          : 'Date TBD'
      } ${
        !event.timeTBD
          ? moment(event.endTime).tz(event.endTz).format('hh:mm A z')
          : 'Time TBD'
      }`;
      name = this.getTravelType(event.travelType);
    }
    if (event.eventCategory === GROUND_TRAVEL) {
      startTime = `${
        !event.dateTBD
          ? moment(event.startTime).tz(event.startTz).format('MMM DD')
          : 'Date TBD'
      }  ${
        !event.timeTBD
          ? moment(event.startTime).tz(event.startTz).format('hh:mm A z')
          : 'Time TBD'
      } `;
      endTime = '';
      name = `Ground Transportation: ${event.eventName} `;
    }
    const attendees = party.members.filter(
      member => event.attendees.map(att => att.id).indexOf(member.memberId) >= 0
    );
    const simpleEvent =
      event.eventCategory !== FLIGHT_TRAVEL &&
      event.eventCategory !== GROUND_TRAVEL;
    const dates = `${startTime} ${endTime}`;
    return (
      <Fragment>
        <Modal
          open={openModal}
          closeModal={this.closeModal}
          cancel={this.closeModal}
          action={modalAction}
          actionButtonText={actionButtonText}
        >
          {modalContent()}
        </Modal>
        {eventUpdated && <Succsess text='event updated' />}
        {serverError && <Error text='server error' />}
        <TopPanel isDetailsPage>
          {backpage && (
            <div
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              type='button'
              className='btn-nav back'
              onClick={this.back}
              style={{ marginLeft: '15px' }}
              aria-label='left Align'
            >
              <i
                className='fas fa-arrow-left'
                style={{ paddingRight: '8px' }}
              />
              <span className='page-back'>Back</span>
              <span className='page-back-mobile'>{name}</span>
            </div>
          )}
          <div className='page-actions'>
            {party.partyStatus !== 'deactivated' && (
              <button
                type='button'
                onClick={this.toEdit}
                style={{ width: '109px', marginRight: '0px m ' }}
                className='btn btn-primary pull-right'
              >
                Edit
              </button>
            )}
            {party.partyStatus !== 'deactivated' && (
              <button
                type='button'
                onClick={this.deleteEvent}
                style={{ width: '97px' }}
                className='btn btn-dang pull-right'
              >
                Delete
              </button>
            )}
          </div>
        </TopPanel>
        <div className='data-container event-container'>
          <div className='data-box'>
            {event.eventCategory === FLIGHT_TRAVEL && (
              <FlightEventView
                title={title}
                name={name}
                dates={dates}
                event={event}
                party={party}
                attendees={attendees}
                allMembers={party.members}
                activity={activity}
              />
            )}
            {event.eventCategory === GROUND_TRAVEL && (
              <GroundTransportEventView
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                title={title}
                name={name}
                dates={dates}
                event={event}
                party={party}
                attendees={attendees}
                allMembers={party.members}
                activity={activity}
                images={images}
              />
            )}
            {simpleEvent && (
              <EventView
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                title={title}
                name={name}
                dates={dates}
                event={event}
                orders={eventOrders}
                party={party}
                attendees={attendees}
                images={images}
                allMembers={party.members}
                activity={activity}
              />
            )}
          </div>
          {eventOrders.length > 0 && (
            <div className='data-box'>
              <EventOrderList
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                orders={eventOrders}
                handleOnClick={this.toOrderInfo}
                party={party}
              />
            </div>
          )}
          <div className='page-actions-mobile'>
            {party.partyStatus !== 'deactivated' && (
              <button
                type='button'
                onClick={this.toEdit}
                style={{ width: '109px', marginRight: '0px m ' }}
                className='btn btn-primary pull-right'
              >
                Edit
              </button>
            )}
            {party.partyStatus !== 'deactivated' && (
              <button
                type='button'
                onClick={this.deleteEvent}
                style={{ width: '97px' }}
                className='btn btn-dang pull-right'
              >
                Delete
              </button>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}
